// Patch per aggiornare l'ID della variante nel form
document.addEventListener('DOMContentLoaded', function() {
  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  // Aggiungi listener per tutti i cambi di variante
  variantSelects.addEventListener('change', function(event) {
    // Attendi un po' che il web component nativo processi il cambio
    setTimeout(() => {
      updateVariantId();
    }, 50);
  });

  function updateVariantId() {
    const variantData = getVariantData();
    const selectedOptions = getSelectedOptions();
    
    if (!variantData || !selectedOptions) return;

    // Trova la variante corrispondente alle opzioni selezionate
    const currentVariant = variantData.find(variant => {
      return variant.options.every((option, index) => {
        return selectedOptions[index] === option;
      });
    });

    if (currentVariant) {
      // Aggiorna tutti gli input con name="id"
      const productForms = document.querySelectorAll('form[action*="cart/add"]');
      productForms.forEach(form => {
        const input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Aggiorna l'URL se necessario
      const sectionId = variantSelects.dataset.section;
      const productUrl = document.querySelector(`#ProductInfo-${sectionId}`)?.dataset?.url || window.location.pathname;
      
      if (window.history && window.history.replaceState) {
        const newUrl = `${productUrl}?variant=${currentVariant.id}`;
        window.history.replaceState({}, '', newUrl);
      }
    }
  }

  function getVariantData() {
    const script = variantSelects.querySelector('script[type="application/json"]');
    if (!script) return null;
    
    try {
      // Il dato potrebbe essere nel data-selected-variant o direttamente nel contenuto
      if (script.hasAttribute('data-selected-variant')) {
        // Dawn recente usa questo formato
        const allVariants = window.productVariants || [];
        return allVariants;
      } else {
        return JSON.parse(script.textContent);
      }
    } catch (e) {
      console.error('Errore parsing variant data:', e);
      return null;
    }
  }

  function getSelectedOptions() {
    const options = [];
    
    // Gestisci radio buttons (swatch e pill)
    const fieldsets = variantSelects.querySelectorAll('fieldset');
    fieldsets.forEach(fieldset => {
      const checked = fieldset.querySelector('input:checked');
      if (checked) {
        options.push(checked.value);
      }
    });

    // Gestisci dropdown selects
    const selects = variantSelects.querySelectorAll('select');
    selects.forEach(select => {
      if (select.value) {
        options.push(select.value);
      }
    });

    return options;
  }

  // Esegui una volta all'avvio per impostare la variante corretta
  updateVariantId();
});